export default __webpack_public_path__ + "static/media/ic-operation.43b20e8b.svg";